'use strict';

import _ from 'lodash';

module.exports = function(testSeed) {
	return _.isFinite(testSeed) && testSeed >= 0 && testSeed < 1;
};
